<template>
    <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="navbar_hoverEffect_second" d="M13.5 1C6.60753 1 1.00003 5.8873 1.00003 11.8947C1.00003 13.995 1.68628 16.0291 2.9867 17.7876C2.74045 20.4253 2.08045 22.3835 1.12212 23.3112C0.99545 23.4339 0.963784 23.6215 1.04378 23.7765C1.11503 23.9149 1.26045 24 1.4167 24C1.43587 24 1.45545 23.9988 1.47503 23.996C1.64378 23.973 5.56378 23.4262 8.39877 21.842C10.0092 22.4711 11.7242 22.7895 13.5 22.7895C20.3925 22.7895 26 17.9022 26 11.8947C26 5.8873 20.3925 1 13.5 1Z" stroke-width="2"/>
        <rect x="9.5" y="8.5" width="8" height="1" rx="0.5" class="navbar_hoverEffect" stroke-linejoin="round"/>
        <rect x="9.5" y="13.5" width="8" height="1" rx="0.5" class="navbar_hoverEffect" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
  name: 'ChatIcon'
}
</script>

<style scoped>
path {
    stroke: var(--nav-menu-new-icon);
}
rect {
    stroke: var(--nav-menu-new-icon);
}
</style>
